import { getagents } from "../../js/api/getAgents.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
import { AccountBalanceTable } from "../components/AccountBalanceTable.js";

let role = "";
let accountStartDate;
let accountEndDate;
let today = new Date();
let dd = String(today.getDate()).padStart(2, "0");
let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
let yyyy = today.getFullYear();

today = yyyy + "-" + mm + "-" + dd;
let startDate = today;
let endDate = today;

let reports = [];

let AccountBalanceNew = {
  firstLoaded: false,
  render: async () => {
    reports = [];
    role = localStorage.getItem("role");

    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));
      console.log(userCoins);
      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}">${_t("Monedha")}: ${Utils.currencyCode(coin.currency)}</option>`;
      });
    }

    let agents = await getagents(startDate, endDate, userCoins[0]);
    let agentsView = "";

    if (agents && agents.children_users.length !== 0) {
      const allIds = agents.children_users.map((a) => a.id);
      const uniqueIds = [...new Set(allIds)];
      uniqueIds.forEach((agentId) => {
        const agent = agents.children_users.find((a) => a.id === agentId);
        agentsView =
          agentsView + `<option value="${agent.id}">${agent.username}</option>`;
      });
    }

    let view = /*html*/ `
      <div id="accountBalancePage">
            <div class="changePasswordHeader">
                 <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
                 <span>${_t("Financa")}</span>
           </div>

           <div class="newMyBetsFilter">
            <input type="text" readonly  class="form-control" id="myCalendar1">
            <button type="button" class="btn-filter">${_t("Filtro")}</button>
           </div>

           <div class="my-bets-tabs" id="predefinedRanges">
           </div>

           <div class="my-bets-select-filters hidden">
            <select name="accountAgentSelect" id="accountAgentSelect" class="${role == "User" ? "hidden" : ""}">
              <option value="">${_t("Zgjidh perdorues")}</option>
              ${agentsView}
            </select>
           </div>

           <div class="accountBalanceWrapper ${role != "User" ? "agentColumn" : ""}">
                <div class="accountBalanceContent">
                    <div class="accountBalanceContentHeader m-t-6 superMenagerHeader">
                        ${role != "User" ? ` <span>${_t("Info")}</span>` : "<span>*</span>"}
                        <span>${_t("Xhiro")}</span>
                        <span>${_t("Fitimi")}</span>
                        <span>${_t("Jackpot")}</span>
                        ${role != "User" ? "<span>%</span>" : ""}
                        ${role != "User" ? ` <span>${_t("Diferenca")}</span>` : ""}
                        ${role == "User" ? ` <span>${_t("Diferenca")}</span>` : ""}
                    </div>
                    
                    <div class="accountBalanceRows" id="accountBalanceTbl">
                    </div>
                </div>
            </div>
          </div>
       `;
    return view;
  },
  after_render: async () => {
    $("body #predefinedRanges .my-bets-tabs__item").unbind("click");

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let months = [
      _t("Janar"),
      _t("Shkurt"),
      _t("Mars"),
      _t("Prill"),
      _t("Maj"),
      _t("Qershor"),
      _t("Korrik"),
      _t("Gusht"),
      _t("Shtator"),
      _t("Tetor"),
      _t("Nentor"),
      _t("Dhjetor"),
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {};
    ranges[_t("Sot")] = [moment(), moment()];
    ranges[_t("Dje")] = [
      moment().subtract(1, "days"),
      moment().subtract(1, "days"),
    ];
    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];
    today = yyyy + "-" + mm + "-" + dd;
    let startDate = today;
    let endDate = today;
    accountStartDate = startDate;
    accountEndDate = endDate;

    const userId = $("#accountAgentSelect").val();

    reports.push(
      new AccountBalanceTable({
        root: "#accountBalanceTbl",
        type: "Baste",
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        isOpen: true,
      }),
    );
    reports.push(
      new AccountBalanceTable({
        root: "#accountBalanceTbl",
        type: "ALL GAMES",
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        isOpen: false,
      }),
    );
    if (location.host === "probast.co") {
      reports.push(
        new AccountBalanceTable({
          root: "#accountBalanceTbl",
          type: "Casino",
          startDate: startDate,
          endDate: endDate,
          userId: userId,
          isOpen: false,
        }),
      );
    } else {
      reports.push(
        new AccountBalanceTable({
          root: "#accountBalanceTbl",
          type: "Casino",
          startDate: startDate,
          endDate: endDate,
          userId: userId,
          isOpen: false,
        }),
      );
      reports.push(
        new AccountBalanceTable({
          root: "#accountBalanceTbl",
          type: "Live/Casino",
          startDate: startDate,
          endDate: endDate,
          userId: userId,
          isOpen: false,
        }),
      );
      reports.push(
        new AccountBalanceTable({
          root: "#accountBalanceTbl",
          type: "Deluxe",
          startDate: startDate,
          endDate: endDate,
          userId: userId,
          isOpen: false,
        }),
      );
    }
    reports.push(new AccountBalanceTable({ root: '#accountBalanceTbl', type: 'Reeltrix Casino', startDate: startDate, endDate: endDate, userId: userId, isOpen: false }));
    reports.push(new AccountBalanceTable({ root: '#accountBalanceTbl', type: 'Evo-Casino', startDate: startDate, endDate: endDate, userId: userId, isOpen: false }));
    reports.push(
      new AccountBalanceTable({
        root: "#accountBalanceTbl",
        type: "Vip Casino",
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        isOpen: false,
      }),
    );
    reports.push(
      new AccountBalanceTable({
        root: "#accountBalanceTbl",
        type: "Virtual",
        startDate: startDate,
        endDate: endDate,
        userId: userId,
        isOpen: false,
      }),
    );

    

    $("#myCalendar1").daterangepicker(
      {
        // ranges: ranges,
        alwaysShowCalendars: false,
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
        opens: "center",
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false,
        opens: "center",
        locale: {
          direction: "ltr",
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: "Apliko",
          cancelLabel: "Anulo",
          fromLabel: "Da",
          toLabel: "A",
          customRangeLabel: "Personalizzata",
          daysOfWeek: ["DI", "HA", "MA", "ME", "EN", "PR", "SH"],
          monthNames: months,
          firstDay: 1,
        },
      },
      async function (start, end, label) {
        $("#predefinedRanges .my-bets-tabs__item.active").removeClass("active");
        $("#contentLoader").append(
          '<div class="loaderWrapper">\n' +
            '            <div class="loader"></div>\n' +
            "        </div>",
        );
        let startDate = start.format("YYYY-MM-DD");
        let endDate = end.format("YYYY-MM-DD");
        accountStartDate = startDate;
        accountEndDate = endDate;

        reports.forEach((report) =>
          report.setDate(accountStartDate, accountEndDate),
        );

        $("body .loaderWrapper").remove();
      },
    );

    Object.keys(ranges).forEach((key) => {
      $("#predefinedRanges").append(
        `<div class="my-bets-tabs__item ${key === "Sot" ? "active" : ""}" data-value="${key}">${key}</div>`,
      );
    });

    $("body #predefinedRanges .my-bets-tabs__item").on(
      "click",
      async function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const key = $(this).attr("data-value");
        if (ranges[key] !== undefined) {
          const range = ranges[key];
          if (range && range.length === 2) {
            $("#myCalendar1").data("daterangepicker").setStartDate(range[0]);
            $("#myCalendar1").data("daterangepicker").setEndDate(range[1]);
            console.log(range[0].format(), "123123");
            accountStartDate = range[0].format().split("T")[0];
            accountEndDate = range[1].format().split("T")[0];
            console.log("Setting dates");
            reports.forEach((report) =>
              report.setDate(accountStartDate, accountEndDate),
            );
          }
        }

        $("#predefinedRanges .my-bets-tabs__item.active").removeClass("active");
        $(this).addClass("active");
      },
    );

    $("body").on("change", "#accountAgentSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const userId = $("#accountAgentSelect").val();
      reports.forEach((report) => report.setUserId(userId));
    });

    $("body").on("change", "#casinoAccountSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });
  },
  hideFooterCasino: true,
};

export default AccountBalanceNew;
